export default [
  {
    path: 'managestaff-new',
    name: 'laborManagement.opsprofile',
    meta: {
      title: 'Staff Profile',
    },
    redirect: '/wms-labormanagement/staffmanagement/managestaff',
  },
];
